import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

// Sticky banner shown while a support (login-as) session is active. It makes the
// impersonation unmistakable and gives a one-click exit. The `support_session`
// flag is cosmetic — it never grants privilege; the real session is a normal
// end-user session. Exit uses signOut({ scope: "local" }) so it ends ONLY this
// session, never the user's real sessions elsewhere.
const TIMEOUT_MS = 45 * 60 * 1000;

function clearFlags() {
  try {
    sessionStorage.removeItem("support_session");
    sessionStorage.removeItem("support_session_started");
  } catch {
    /* ignore */
  }
}

async function endSupportSession() {
  try {
    await supabase.auth.signOut({ scope: "local" });
  } catch {
    /* ignore */
  }
  clearFlags();
  window.location.assign("/");
}

export function SupportSessionBanner() {
  const [active, setActive] = useState(false);

  useEffect(() => {
    const check = () => {
      let on = false;
      try {
        on = sessionStorage.getItem("support_session") === "1";
      } catch {
        on = false;
      }
      setActive(on);
      if (on) {
        const started = Number(sessionStorage.getItem("support_session_started") || 0);
        if (started && Date.now() - started > TIMEOUT_MS) {
          void endSupportSession();
        }
      }
    };
    check();
    const id = window.setInterval(check, 60_000);
    return () => window.clearInterval(id);
  }, []);

  if (!active) return null;

  // TEMPORAL (2026-07): acceso de soporte silencioso. Se retira el aviso llamativo
  // (barra ámbar "El soporte de Ulture está accediendo a tu cuenta") a petición de
  // soporte. Se conserva SOLO un control de salida discreto en la esquina — más el
  // auto-cierre por inactividad de arriba — para que el agente pueda cerrar la
  // sesión de soporte de forma limpia. Para volver al aviso completo, revertir.
  return (
    <button
      type="button"
      onClick={() => void endSupportSession()}
      title="Cerrar la sesión de soporte de Ulture"
      aria-label="Cerrar la sesión de soporte"
      style={{ position: "fixed", bottom: 8, right: 8, zIndex: 2147483647, opacity: 0.4 }}
      className="rounded bg-black/50 px-2 py-0.5 text-[10px] font-medium text-white shadow-sm transition-opacity hover:opacity-100"
    >
      Salir soporte
    </button>
  );
}
